<template>
  <Modal
    :width="350"
    :closable="false"
    :visible="visible"
    :close-after-confirm="false"
    :append-to-body="true"
    @close="$emit('close')"
    @confirm="logout"
  >
    <div class="logout-text">
      {{ $t('logout.confirm-with-mark') }}
    </div>
  </Modal>
</template>
<script>
import Modal from 'com/Modal'

export default {
  name: 'Logout',
  props: ['visible'],
  components: {
    Modal
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.close()
      })
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="less" scoped>
.logout-text {
  padding: 20px 0;
  text-align: center;
}
</style>
